import ContentHeader from "tds/contentHeader";

export { ContentHeader };

customElements.define(
  "tds-content-header",
  ContentHeader.CustomElementConstructor
);
